import React from 'react';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import { GetRights } from 'nallian-shared-ui/lib/selectors';
import { hasRight } from 'nallian-shared-ui/lib/lib/routesHelper';
import { Flex, Segment, Loader } from 'nallian-shared-ui/lib/components';
import LegalDocs from './LegalDocs';
import CommunityTexts from './CommunityTexts';
import { WELCOME_TEXT_TYPE_ID, OVERVIEW_TEXT_TYPE_ID } from './constants';

const LegalAndTexts = () => {
  const communityFetch = useSelector(state => get(state, 'repository.community'));
  const communityTag = communityFetch?.value?.tag;
  const communityId = communityFetch?.value?.id;
  const defaultLanguageId = communityFetch?.value?.defaultLanguageId;

  const rights = useSelector(GetRights);
  const canManage = hasRight(rights, 'COMMUNITIES.MANAGE.ALL');
  const canViewTexts = canManage || hasRight(rights, 'COMMUNITYTEXTS.READ.ALL');
  const canViewLegal = canManage || hasRight(rights, 'LEGALDOCUMENTS.READ.ALL');
  const readOnly = !canManage;

  return (
    <Segment basic>
      <Flex fluid direction="column" alignItems="center">
        {communityFetch?.pending && <Loader inline active />}
        {communityFetch?.value && (
          <>
            {canViewTexts && (
              <>
                <CommunityTexts
                  communityTag={communityTag}
                  defaultLanguageId={defaultLanguageId}
                  type={WELCOME_TEXT_TYPE_ID}
                  readOnly={readOnly}
                />
                <CommunityTexts
                  communityTag={communityTag}
                  defaultLanguageId={defaultLanguageId}
                  type={OVERVIEW_TEXT_TYPE_ID}
                  readOnly={readOnly}
                />
              </>
            )}
            {canViewLegal && (
              <LegalDocs
                communityTag={communityTag}
                communityId={communityId}
                readOnly={readOnly}
              />
            )}
          </>
        )}
      </Flex>
    </Segment>
  );
};

export default LegalAndTexts;
